import { DocumentCourseCreate, DocumentCourseList, DocumentCourseDelete } from './Request';

export const listDocumentCourse = async courseId => DocumentCourseList({ courseId });

export const createDocumentCourse = async (courseId, name, size, url) =>
  DocumentCourseCreate({ courseId, name, size, url });

export const deleteDocumentCourse = async id => {
  DocumentCourseDelete({ id });
};

export default {
  listDocumentCourse,
  createDocumentCourse,
  deleteDocumentCourse,
};
